export const CHALLENGE_SOFTWARE_TOKEN_MFA_ISSUED = '@auth/CHALLENGE_SOFTWARE_TOKEN_MFA_ISSUED';
export const CHALLENGE_SOFTWARE_TOKEN_MFA_SUBMITTED = '@auth/CHALLENGE_SOFTWARE_TOKEN_MFA_SUBMITTED';
export const CHALLENGE_SOFTWARE_TOKEN_MFA_ACCEPTED = '@auth/CHALLENGE_SOFTWARE_TOKEN_MFA_ACCEPTED';
export const CHALLENGE_SOFTWARE_TOKEN_MFA_REJECTED = '@auth/CHALLENGE_SOFTWARE_TOKEN_MFA_REJECTED';

export const issueChallengeSoftwareTokenMfa = () => ({
    type: CHALLENGE_SOFTWARE_TOKEN_MFA_ISSUED,
    payload: {},
});

export const submitChallengeSoftwareTokenMfa = ({ code }) => ({
    type: CHALLENGE_SOFTWARE_TOKEN_MFA_SUBMITTED,
    payload: { code },
});

export const acceptChallengeSoftwareTokenMfa = ({ user }) => ({
    type: CHALLENGE_SOFTWARE_TOKEN_MFA_ACCEPTED,
    payload: { user },
});

export const rejectChallengeSoftwareTokenMfa = ({ code }) => ({
    type: CHALLENGE_SOFTWARE_TOKEN_MFA_REJECTED,
    payload: { code },
});
